<template>
  <section>
    <div class="mb-8">
      <VueSlickCarousel v-if="isBannerDataAvailable" v-bind="settings">
        <div v-for="(bannerItm, index) in landingBannerData" :key="index"
          class="rounded-xl h-50 landing-backgroundImage"
          :style="isDesktop() ? { backgroundImage: 'url(' + bannerItm.banner_url + ')' } :
          { backgroundImage: 'url(' + bannerItm.banner_mobile_url + ')' }"
        >
          <!-- <img :src="require(`@/assets/img/${bannerImage}`)" alt="" class="w-full"/> -->
          <!-- absolute text starts here-->
          <!-- <div class="absolute top-0 h-full left-10">
            <div class="flex flex-col justify-center h-full">
              <h3 class="text-white md:text-40px text-2xl font-bold mb-4 leading-snug">
                Full Body Yoga for Strength & flexibility
              </h3>
              <div
                class="flex justify-between rounded-lg md:w-2/5 w-full p-4 md:mt-4 mt-0 time-burn-cover"
              >
                <div class="flex items-center">
                  <img
                    :src="require('@/assets/img/Time.png')"
                    alt="Time image"
                    class="rounded-lg object-cover bg-green-parrot p-2 text-sm"
                  />
                  <div class="flex flex-col px-2">
                    <span class="text-xs text-white">Time</span>
                    <span class="text-sm text-green-light whitespace-nowrap">30 min</span>
                  </div>
                </div>
                <hr class="divide-bg">
                <div class="flex items-center">
                  <img
                    :src="require('@/assets/img/Fire.png')"
                    alt="Time image"
                    class="rounded-lg object-cover bg-green-parrot p-2 text-sm"
                  />
                  <div class="flex flex-col px-2">
                    <span class="text-xs text-white">Burn</span>
                    <span class="text-sm text-green-light">95 kcal</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- absoulte text ends here -->
          <div class="w-fill-available md:w-1/2 bg-black p-6 flex items-center m-6 rounded-xl md:h-fill-available bg-opacity-65">
            <div class="space-y-4 text-white">
              <p class=" sm:text-sm md:text-xl lg:text-2xl 2xl:text-4xl font-bold leading-tight">{{ handleStr(bannerItm.banner_title, 75) }}</p>
              <p class="text-xs md:text-sm">{{ isDesktop() ? handleStr(bannerItm.banner_description, 530) : handleStr(bannerItm.banner_description, 250) }}</p>
              <button
                v-if="bannerItm && bannerItm.redirect_url && bannerItm.redirect_url.length"
                class="bg-green-light hover:bg-green-dark text-white font-bold py-2 px-4 rounded"
                @click="redirectHandler(bannerItm.redirect_url)"
              >
                Join Now
              </button>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import { mapGetters, mapActions } from "vuex";
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  name: "NewHomeBannerImg",
  components:{
    VueSlickCarousel
  },
  data() {
    return {
      LOADING: true,
      settings: {
        //arrows: true,
        dots: true,
      }
    };
  },
  computed: {
    ...mapGetters(["landingBannerData"]),
    isBannerDataAvailable () {
      return this.landingBannerData && this.landingBannerData.length
    }
  },
  methods: {
    redirectHandler (path) {
      window.location.href = path
    }
  }
};
</script>

<style scoped lang="scss">
.time-burn-cover {
  background: rgba(25, 33, 38, 0.3);
}
.divide-bg{
    height: 35px;
    background: rgba(255, 255, 255, 0.25);
    width: 1px;
    position: relative;
    top: 2px;
}
.landing-backgroundImage {
    background-repeat: no-repeat;
    background-position: center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
.banner-height{
  height: 700px;
  background-repeat: no-repeat;
  background-size: cover;
}
@media(max-width: 767px){
   .banner-height{
    height: 500px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
   } 
}
.left-10{
  left: 10%;
}
.h-50 {
  height: 50vh;
}
</style>